/* unplugin-vue-components disabled */import { render } from "./source.vue?vue&type=template&id=5acae762&scoped=true"
import script from "./source.vue?vue&type=script&lang=js"
export * from "./source.vue?vue&type=script&lang=js"

import "./source.vue?vue&type=style&index=0&id=5acae762&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acae762"],['__file',"src/components/sources/source.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5acae762"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5acae762', __exports__)) {
    api.reload('5acae762', __exports__)
  }
  
  module.hot.accept("./source.vue?vue&type=template&id=5acae762&scoped=true", () => {
    api.rerender('5acae762', render)
  })

}


export default __exports__